import CityPageTemplate from "../city-template/CityPageTemplate";
import { grandJunctionConfig } from "./data";

export default function GrandJunctionPage() {
  return <CityPageTemplate config={grandJunctionConfig} />;
}